<script>
    export let data = {}
    const { content, props } = data
</script>

<div class="modal-body">
    <svelte:component this={content} {...props} />
</div>
